import { Fragment, Node, NodeType, Slice } from 'prosemirror-model'
import { RemoveMarkStep, ReplaceStep, Step, Transform } from 'prosemirror-transform'

//--------------------------------------- Functions are taken directly from prosemirror and should not be modified ---------------------------------------

export function replaceNewlines(tr: Transform, node: Node, pos: number, mapFrom: number) {
  node.forEach((child, offset) => {
    if (child.isText) {
      let m, newline = /\r?\n|\r/g
      while (m = newline.exec(child.text!)) {
        let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index)
        tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement!.create())
      }
    }
  })
}

export function replaceLinebreaks(tr: Transform, node: Node, pos: number, mapFrom: number) {
  node.forEach((child, offset) => {
    if (child.type == child.type.schema.linebreakReplacement) {
      let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset)
      tr.replaceWith(start, start + 1, node.type.schema.text("\n"))
    }
  })
}

export function canChangeType(doc: Node, pos: number, type: NodeType) {
  let $pos = doc.resolve(pos), index = $pos.index()
  return $pos.parent.canReplaceWith(index, index + 1, type)
}

export function clearIncompatible(tr: Transform, pos: number, parentType: NodeType,
  match = parentType.contentMatch,
  clearNewlines = true) {
  let node = tr.doc.nodeAt(pos)!
  let replSteps: Step[] = [], cur = pos + 1
  for (let i = 0; i < node.childCount; i++) {
    let child = node.child(i), end = cur + child.nodeSize
    let allowed = match.matchType(child.type)
    if (!allowed) {
      replSteps.push(new ReplaceStep(cur, end, Slice.empty))
    } else {
      match = allowed
      for (let j = 0; j < child.marks.length; j++) if (!parentType.allowsMarkType(child.marks[j].type))
        tr.step(new RemoveMarkStep(cur, end, child.marks[j]))

      if (clearNewlines && child.isText && parentType.whitespace != "pre") {
        let m, newline = /\r?\n|\r/g, slice
        while (m = newline.exec(child.text!)) {
          if (!slice) slice = new Slice(Fragment.from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))),
            0, 0)
          replSteps.push(new ReplaceStep(cur + m.index, cur + m.index + m[0].length, slice))
        }
      }
    }
    cur = end
  }
  if (!match.validEnd) {
    let fill = match.fillBefore(Fragment.empty, true)
    tr.replace(cur, cur, new Slice(fill!, 0, 0))
  }
  for (let i = replSteps.length - 1; i >= 0; i--) tr.step(replSteps[i])
}
